/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticlesService } from '../../services/articles.service';
import { StorageProvider } from '../../services/storage.provider';
import { Logout } from '../../services/logout.provider';

@Component({
  selector: 'app-gar-login',
  templateUrl: 'gar-login.html',
  styleUrls: ['gar-login.scss']
})
export class GarLoginPage {
  public spinner: boolean;
  public buttons: boolean;
  public error: string;
  public access_token: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private service: ArticlesService,
    private storage: StorageProvider,
    private logout: Logout
  ) {}

  ionViewDidLoad() {
    if (
      document.referrer.indexOf('ozecollege.yvelines.fr') > -1 ||
      document.referrer.indexOf('enc.hauts-de-seine.fr') > -1 ||
      document.referrer.indexOf('enc92.fr') > -1 ||
      document.referrer.indexOf('www.ena78.fr') > -1 ||
      document.referrer.indexOf('ena78.fr') > -1
    ) {
      this.logout.logOut();
      if (document.referrer.indexOf('www.ena78.fr') > -1 || document.referrer.indexOf('ena78.fr') > -1) {
        this.service.loginToPlatformGet('lesclesdelecole@playbac.fr', '5uB3M5azmqHn').subscribe(
          (response) => {
            this.access_token = response.access_token;
            this.storage.setStorage('access_token', this.access_token);
            this.goToProfiles();
          },
          (error) => {
            this.error = ' Vos identifiants ne sont pas reconnus';
          }
        );
      } else {
        this.service.loginToPlatformGet('gar@playbac.fr', '9sRPxlHYtz').subscribe(
          (response) => {
            this.access_token = response.access_token;
            this.storage.setStorage('access_token', this.access_token);
            this.goToProfiles();
          },
          (error) => {
            this.error = ' Vos identifiants ne sont pas reconnus';
          }
        );
      }
    } else {
      this.goToHomePage();
    }
  }

  isLogin(): string {
    return 'login';
  }

  goToHomePage() {
    this.router.navigate(['']);
  }

  reconnect() {
    location.reload();
  }

  goToProfiles() {
    this.router.navigate(['profiles'], { queryParams: { cas: true } });
  }
}
